import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { UpdateSupaMachinesResponse } from '../types/deployer-grid-responses';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DeployerRelayData, DeployerRelaysEndpointMethod } from '../types';

export class DeployerGridBaseDataProvider extends BaseWebComponentDataProvider {
  public async updateSupaMachines(records: Array<DeployerRelayData>): Promise<UpdateSupaMachinesResponse> {
    return await ConsoleRequest.createRequest<UpdateSupaMachinesResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        records: records,
      },
      endpoint: 'ProtectedEntities',
      method: DeployerRelaysEndpointMethod.UPDATE_SUPA_MACHINES,
    });
  }
}
